// extracted by mini-css-extract-plugin
export default {"down":"D58ghB2WhxuzhaG7AGdh","left":"gzZDQPi1jkCMK9g8goxC","up":"gOkOiJWJ5ACiVUh4otR3"};